<template>
  <div class="flex flex-col bg-gray-600 min-h-screen">
    <el-scrollbar class="flex-grow">
      <div class="mb-40">
        <router-view v-slot="{ Component }">
          <transition name="route" mode="out-in">
            <component :is="Component"></component>
          </transition>
        </router-view>
      </div>
    </el-scrollbar>
    <TheFooter v-if="!isIframe" />
  </div>
</template>
<script setup>
import "@/assets/tailwind.css";
import { ref } from "vue";
import TheFooter from "@/components/TheFooter.vue";
import { ElScrollbar } from "element-plus";

const isIframe = ref(window.self !== window.top);
</script>

<style>
app {
  font-family: "Tommy";
  src: local("Tommy"), url(./fonts/Tommy/TOMMY-Bold.otf) format("opentype");
}

/* route transitions */
.route-enter-from {
  opacity: 0;
}

.route-enter-active {
  transition: all 0.3s ease-out;
}

.route-leave-to {
  opacity: 0;
}

.route-leave-active {
  transition: all 0.3s ease-in;
}

/* 
::-webkit-scrollbar {
  display: none;
}

::-webkit-scrollbar-thumb {
  display: none;
} */
</style>
